import { ExtensionAttributeKeys } from "./ServiceRequest.models";

export enum URLs {
  EmeraldWeb = 'https://support.microsoft.com/{0}/home/contact',
  SmcContactUsLandingPage = 'https://support.microsoft.com/contactus'
};

export enum QueryParamKeys {
  ReconnectId = 'oc.reconnectid',
  SourceApp = 'sourceapp',
  Theme = 'theme',
  CustomContext = 'customcontext'
};

export const OcCustomContextExtensionAttributeKeys: ExtensionAttributeKeys[]  = [
  ExtensionAttributeKeys.Theme,
  ExtensionAttributeKeys.ThemeL1,
  ExtensionAttributeKeys.ThemeL2,
  ExtensionAttributeKeys.ThemeL3,
  ExtensionAttributeKeys.AppName
];